// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3tdtI","empty":"ModalGraph_empty__3v05W"};